module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "point-list"
  }, _vm._l((_vm.$store.state.oHomePage.size), function(i) {
    return _c('div', {
      staticClass: "point",
      class: {
        active: i == _vm.$store.state.oHomePage.index
      },
      on: {
        "click": function($event) {
          _vm.$store.state.oHomePage.index = i
        }
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "page-group",
    style: ({
      transform: 'translateY(-' + ((_vm.$store.state.oHomePage.index - 1) * 100) + 'vh)'
    })
  }, [_c('page_1'), _vm._v(" "), _c('page_2'), _vm._v(" "), _c('page_3'), _vm._v(" "), _c('page_4'), _vm._v(" "), _c('page_5'), _vm._v(" "), _c('page_6')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-11237119"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 769
// module chunks = 1